import React, { useEffect, useState } from 'react';

// Displays countdown timer for the FIRST removed slot only per product requirement
export default function CooldownTimer({ cooldowns = [] }) {
  const earliest = cooldowns.length
    ? [...cooldowns].sort((a, b) => a.expiresAt - b.expiresAt)[0]
    : null;

  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!earliest) {
      setRemaining(0);
      return;
    }
    const tick = () => {
      const endAt = earliest.expiresAt;
      setRemaining(Math.max(0, endAt - Date.now()));
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [earliest]);

  if (!earliest || remaining <= 0) return null;

  const h = Math.floor(remaining / (1000 * 60 * 60));
  const m = Math.floor((remaining / (1000 * 60)) % 60);
  const s = Math.floor((remaining / 1000) % 60);

  const pad = (n) => String(n).padStart(2, '0');

  return (
    <div className="flex items-center gap-3 px-4 py-2 rounded neon-card-cyan">
      <div className="w-2 h-2 rounded-full bg-cyan-300 pulse-ring" />
      <div>
        <div className="text-[10px] uppercase tracking-widest text-cyan-300/80">Slot Cooldown</div>
        <div className="font-mono-display text-lg tabular text-white">
          {pad(h)}:{pad(m)}:{pad(s)}
        </div>
      </div>
      {cooldowns.length > 1 && (
        <div className="text-[10px] uppercase tracking-widest text-zinc-400 border-l border-zinc-700 pl-3">
          +{cooldowns.length - 1} more<br/>in queue
        </div>
      )}
    </div>
  );
}
